/**
 * Public, no-sign-up Studio demo (2026-10-16): https://studio.legit2clip.com/studio-app/?demo=1
 *
 * The demo opens a real SecKC talk excerpt that legit2clip already transcribed and clipped, so a
 * visitor sees the tool's actual output (transcript, highlight picks, captions, crop) before they
 * are asked for anything. Everything that needs an account (the assistant, generation, saving,
 * exporting) shows a sign-up prompt instead of bouncing the visitor to a login page.
 *
 * Studio itself is a Pro feature on legit2clip (server: require_studio_access), so the demo's main
 * call to action is Pro; the free plan (automatic clips from a long video) is the second option.
 */
export const IS_DEMO =
  typeof window !== 'undefined' && new URLSearchParams(window.location.search).has('demo')

export const DEMO_SAMPLE_ID = 'seckc-one-click'

const SITE = 'https://www.legit2clip.com'
export const DEMO_PRO_URL = `${SITE}/pro?from=studio-demo`
export const DEMO_SIGNUP_URL = `${SITE}/signup?from=studio-demo`
export const DEMO_HOME_URL = SITE
